import * as angular from 'angular';
import {IController} from "angular";
import {FulfillmentStepModel} from "../../../fulfillment/models/fulfillment-step.model";
import {SplitService} from "../../../commons/services/split-service.service";
import {MissingItemModel} from "../../models/missing-item.model";
import * as _ from "lodash";
import {ServiceItem} from "../../../commons/models/service-item.model";
import {OperationalContactModel} from "../../../commons/angular/models/operational-contact.model";

export class ServiceOperationalContactsDialogViewComponent implements IController {

  operationalContacts: OperationalContactModel[];
  onReset: Function;
  onAdd: Function;
  onRemove: Function;
  onChange: Function;

  constructor() {

  }

  $onInit() {

  }

  $onChanges(changes: angular.IOnChangesObject) {

  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceOperationalContactsDialogView', {
    require: {
      form: '^form'
    },
    bindings: {
      operationalContacts: '<',
      onReset: '&',
      onAdd: '&',
      onRemove: '&',
      onChange: '&'
    },
    template: require('./service-operational-contacts-dialog-view.html').default,
    controller: ServiceOperationalContactsDialogViewComponent
  });
